import classNames from 'clsx';
import { Divider } from 'aui';
import isBoolean from 'lodash-es/isBoolean';
import isNumber from 'lodash-es/isNumber';
import isObject from 'lodash-es/isObject';
import isString from 'lodash-es/isString';
import type { MdComponentIndexProps } from '../type';
// import { useRef } from 'react';
// import styles from './Tooltip.module.less';

type MarkdownDividerProps = React.ComponentProps<typeof Divider>;

function validateProps(props: MarkdownDividerProps) {
  const res = { ...props };
  if (!isString(res.className)) res.className = undefined;
  if (!isBoolean(res.dashed)) res.dashed = undefined;
  if (!isString(res.orientation)) res.orientation = undefined;
  if (!isString(res.orientationMargin) && !isNumber(res.orientationMargin))
    res.orientationMargin = undefined;
  if (!isBoolean(res.dashed)) res.dashed = undefined;
  if (!isObject(res.style)) res.style = undefined;
  if (!isString(res.type)) res.type = undefined;
  return res;
}

export function MarkdownDivider(
  props: React.PropsWithChildren<MarkdownDividerProps & MdComponentIndexProps>,
) {
  return (
    <Divider
      {...validateProps(props)}
      data-first={props['data-first']}
      data-last={props['data-last']}
    >
      {props.children ? (
        <span className={classNames('markdown-child-root')}>{props.children}</span>
      ) : null}
    </Divider>
  );
}

MarkdownDivider.attributes = [
  'className',
  'dashed',
  'orientation',
  'orientationMargin',
  'plain',
  'style',
  'type',
];
MarkdownDivider.inline = true;
